import { useEffect } from "preact/hooks";
import { useComputed } from "@preact/signals";
import { useApp } from "~/core";

const MAX_TASKS = 10;

const useTrackerTasks = () => {
    const {
        api: { task: taskApi, status, connection },
    } = useApp();
    const user = connection.value?.user;

    useEffect(() => {
        taskApi.listenAll();
    }, [taskApi]);

    const myTasks = useComputed(() => {
        if (!user) {
            return [];
        }

        return taskApi.all.value
            .map((task) => ({
                task,
                me: task.users.value.find((item) =>
                    item._assignee?.equals(user.user_id),
                ),
            }))
            .filter((item) => item.me);
    });

    const tasks = useComputed(() => {
        const inProgress: (typeof myTasks)["value"] = [];
        const idle: (typeof myTasks)["value"] = [];
        const upcoming: (typeof myTasks)["value"] = [];

        for (const item of myTasks.value) {
            const taskStatus = item.me?.status;

            if (!taskStatus || taskStatus.equals(status.DONE._id)) {
                continue;
            }

            if (taskStatus.equals(status.IN_PROGRESS._id)) {
                inProgress.push(item);
            } else if (taskStatus.equals(status.IDLE._id)) {
                idle.push(item);
            } else {
                upcoming.push(item);
            }
        }

        upcoming.sort(
            (a, b) =>
                (a.task.budgeted_start ?? Infinity) -
                (b.task.budgeted_start ?? Infinity),
        );

        return [...inProgress, ...idle, ...upcoming]
            .slice(0, MAX_TASKS)
            .map((item) => item.task);
    });

    return { tasks, loading: taskApi.allLoading };
};

export default useTrackerTasks;
